module.exports = "<!-- <div>\n</div> -->\n<router-outlet></router-outlet>"